<template>
  <div class="cpt-rotating-bg" v-if="bg">
    <img :src="bg" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    bg: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="less" scoped>
.cpt-rotating-bg {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
